import React from 'react'

const Receipt = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.625 1.875H13.1562V1.40625C13.1562 0.630844 12.5254 0 11.75 0H2.375C1.59959 0 0.96875 0.630844 0.96875 1.40625V12.7188C0.96875 13.4942 1.59959 14.125 2.375 14.125H2.84375V14.5938C2.84375 15.3692 3.47459 16 4.25 16H13.625C14.4004 16 15.0312 15.3692 15.0312 14.5938V3.28125C15.0312 2.50584 14.4004 1.875 13.625 1.875ZM3.25563 3.61272C2.99 3.87831 2.84375 4.23144 2.84375 4.60706V13.1875H2.375C2.11653 13.1875 1.90625 12.9772 1.90625 12.7188V1.40625C1.90625 1.14778 2.11653 0.9375 2.375 0.9375H11.75C12.0085 0.9375 12.2188 1.14778 12.2188 1.40625V1.875H5.57581C5.20019 1.875 4.84706 2.02128 4.58147 2.28688L3.25563 3.61272ZM5.65625 2.8125V4.6875H3.78125V4.60706C3.78125 4.48187 3.83 4.36416 3.91853 4.27563L5.24438 2.94978C5.33291 2.86125 5.45062 2.8125 5.57581 2.8125H5.65625ZM14.0938 14.5938C14.0938 14.8522 13.8835 15.0625 13.625 15.0625H4.25C3.99153 15.0625 3.78125 14.8522 3.78125 14.5938V5.625H6.125C6.38387 5.625 6.59375 5.41512 6.59375 5.15625V2.8125H13.625C13.8835 2.8125 14.0938 3.02278 14.0938 3.28125V14.5938Z"
        fill="#F05A26"
      />
      <path
        d="M12.6875 6.625H5.1875C4.92862 6.625 4.71875 6.83487 4.71875 7.09375C4.71875 7.35263 4.92862 7.5625 5.1875 7.5625H12.6875C12.9464 7.5625 13.1562 7.35263 13.1562 7.09375C13.1562 6.83487 12.9464 6.625 12.6875 6.625Z"
        fill="#F05A26"
      />
      <path
        d="M12.6875 8.5H5.1875C4.92862 8.5 4.71875 8.70987 4.71875 8.96875C4.71875 9.22763 4.92862 9.4375 5.1875 9.4375H12.6875C12.9464 9.4375 13.1562 9.22763 13.1562 8.96875C13.1562 8.70987 12.9464 8.5 12.6875 8.5Z"
        fill="#F05A26"
      />
      <path
        d="M12.6875 10.375H5.1875C4.92862 10.375 4.71875 10.5849 4.71875 10.8438C4.71875 11.1026 4.92862 11.3125 5.1875 11.3125H12.6875C12.9464 11.3125 13.1562 11.1026 13.1562 10.8438C13.1562 10.5849 12.9464 10.375 12.6875 10.375Z"
        fill="#F05A26"
      />
      <path
        d="M12.6875 12.25H5.1875C4.92862 12.25 4.71875 12.4599 4.71875 12.7188C4.71875 12.9776 4.92862 13.1875 5.1875 13.1875H12.6875C12.9464 13.1875 13.1562 12.9776 13.1562 12.7188C13.1562 12.4599 12.9464 12.25 12.6875 12.25Z"
        fill="#F05A26"
      />
    </svg>
  )
}

export default Receipt
